import { Component, Input, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-text-input-row',
  templateUrl: './text-input-row.component.html',
  styleUrl: './text-input-row.component.scss'
})
export class TextInputRowComponent {
  @Input({ required: false }) label?: string;
  @Input({ required: true }) placeholder: string;
  @Input({ required: false }) errorMessage = '';
  @Input({ required: true }) control: FormControl;
  @Input({ required: false }) type: "text" | "number" | "password";
  @Input({ required: false }) width = "30%";
  @Input({ required: false }) isResponsive = true;
  @Input({ required: false }) formatAsMoney = false;

  isInvalid(): boolean {
    const control = this.control;
    return control ? control.invalid && (control.dirty || control.touched) : false;
  }

  constructor(
    @Inject(DOCUMENT) private document: Document
  ) { }

  get pageDirection(): string {
    return this.document.documentElement.dir || 'ltr';
  }

  isRtl(): boolean {
    return this.pageDirection.toLowerCase() === 'rtl';
  }
}
